/* FILE: ./frontend/src/features/common/components/DisputeModal.jsx */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next'; // ⚡ ADDED

export default function DisputeModal({ reason, companyName, onClose }) {
  const { t } = useTranslation(); // ⚡ ADDED
  const [comments, setComments] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleDispute = (e) => {
    e.preventDefault();

    // In a real app, you would POST this to an endpoint like /api/v1/support/dispute
    console.log("Dispute Filed:", { companyName, reason, comments });

    // Simulate API delay
    setTimeout(() => {
        setSubmitted(true);
    }, 500);

  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
      <div className="bg-white rounded-xl shadow-2xl max-w-lg w-full overflow-hidden border border-red-100">
        
        {/* Header */}
        <div className="bg-red-50 p-6 border-b border-red-100">
          <div className="flex items-center gap-3">
            <div className="bg-red-100 p-2 rounded-full">
            
                 <span className="text-2xl">⛔</span>
            </div>
            <div>
                <h2 className="text-xl font-bold text-red-900">{t('dispute.title')}</h2>
                <p className="text-red-700 text-sm">{t('dispute.subtitle')}</p>
            </div>
          </div>
        </div>

 
        <div className="p-6">
          {!submitted ? (
            <>
              <p className="text-gray-600 text-sm mb-4">
                {t('dispute.desc_1')}
              </p>
              
              <div className="bg-gray-50 p-3 rounded border border-gray-200 mb-6">
                <span className="text-xs font-bold text-gray-500 uppercase tracking-wide">{t('dispute.reason')}</span>
                <p className="text-gray-800 font-medium mt-1">{reason}</p>
              </div>

           
               <form onSubmit={handleDispute}>
                <label className="block text-sm font-bold text-gray-700 mb-2">
                    {t('dispute.believe_error')}
                </label>
                <textarea 
                    required
                    className="w-full border p-3 rounded-lg focus:ring-2 focus:ring-blue-500 min-h-[100px] text-sm"
                    placeholder={t('dispute.ph_explain')}
                    value={comments}
                    onChange={e => setComments(e.target.value)}
                />
                
                <div className="flex gap-3 mt-6">
      
                     <button 
                        type="button" 
                        onClick={onClose}
                        className="flex-1 px-4 py-2 border border-gray-300 text-gray-600 rounded-lg hover:bg-gray-50 font-medium"
    
                 >
                        {t('dispute.cancel')}
                    </button>
                    <button 
                   
      type="submit" 
                        className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 font-bold shadow-sm"
                    >
                        {t('dispute.submit')}
                 
    </button>
                </div>
              </form>
            </>
          ) : (
            <div className="text-center py-8">
                <div className="text-4xl mb-4">✅</div>
           
      <h3 className="text-xl font-bold text-gray-900">{t('dispute.received')}</h3>
                <p className="text-gray-600 mt-2 text-sm">
                    {t('dispute.received_desc_1')}
                </p>
                <button 
                    onClick={onClose} 
                    className="mt-6 bg-gray-900 text-white px-6 py-2 rounded-lg font-bold"
                >
           
          {t('dispute.close')}
                </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );

}